export enum SectionState {
  ALLOWED = 'ALLOWED',
  LOCKED = 'LOCKED',
  REQUIRED = 'REQUIRED',
  HIDDEN = 'HIDDEN',
  AT_NDC = '@NDC'
}
